module.exports = __webpack_public_path__ + "img/新浪_副本.2319776e.png";